<template>
	<div class="clearfix rounded pb-5 mx-auto">   <!-- Abdullah removed class company-form-container mt-4 px-3 -->

        <!-- Abdullah commented this  -->
		<!-- <div class="clearfix row py-2 mb-2 border-bottom">
			<div class="col-sm-6 px-3 company-form-box-title">
				Pay Slip & Tax Card Designer
			</div>
		</div> -->

        <!-- Abdullah added this -->
        <h4 class="atlhr-dashboard-title mt-10 px-0 mb-0">Payroll Settings<span>
            <!-- alpha fix- chnaged here Payslip Designer  -->
            <a v-bind:href="$api_url+'/company/dashboard'">Dashboard</a> / Settings / Payroll Settings / Payslip Designer</span>
        </h4>

        <div class="row no-margin mt-4">  <!-- Abdullah added this div -->
            <div class="ibox col-md-12 px-4">  <!-- Abdullah added this div -->

                <!-- Abdullah added this code -->
                <div class="ibox-title dashboard_title px-0">
                    <h4>Pay Slip and Tax Card Designer</h4>
                </div>

                <div class="ibox-content px-0 pt-4"> <!-- Abdullah added this div -->
                    <div class="row trz_dynamic_field_wrapper"> <!-- Abdullah removed class  px-3-->
                        <div class="col-sm-3 mb-3 mt-3" >
                            <div class="d-inline-block trz_fields trz-custom-dropdown white-dropdown-icon mb-3 w-100" > <!-- Abdullah added class white-dropdown-icon mb-3 w-100-->
                                <b-dropdown id="dropdown-fields"  text="Add Header Fields (1st Colunm)" ref="dropdown" class="mb-1 position-relative w-100"> <!-- Abdullah chnaged title text and added class w-100-->
                                    <b-dropdown-form>
                                        <b-form-group @submit.stop.prevent>
                                            <div class="form-group">
                                                <b-form-checkbox-group
                                                    v-model="header_column_selected"
                                                    :options="column_options"
                                                    switches

                                                />
                                            </div>

                                        </b-form-group>
                                    </b-dropdown-form>
                                </b-dropdown>
                            </div>


                            <div v-for="(row, index) in header_column_selected_view" :key="index">
                                <div class="trz_field_values">
                                    <b-form-group class="header-fields" >   <!-- Abdullah removed class style='max-width:238px;' -->

                                        <b-form-input class = "d-inline-block p-1 px-3 mr-2 align-middle" disabled  :value="stringView(row)"></b-form-input>
                                        <div class="trz_delete_button payslip-designer-delete"> <!-- Abdullah added class payslip-designer-delete-->
                                            <!-- Abdullah commented this btn  -->
                                            <!-- <b-icon class="" variant="secondary" @click="removeEntryModal('header-left',row)" icon="trash-fill" role="button" aria-hidden="true" scale="1.5" ></b-icon>   -->

                                            <!-- Abdullah added this  -->
                                            <b-icon class="" variant="secondary" @click="removeEntryModal('header-left',row)" icon="x" role="button" aria-hidden="true" scale="1.5" ></b-icon>
                                        </div>
                                    </b-form-group>
                                </div>
                            </div>

                        </div>
                        <div class="col-sm-3 mb-3 mt-3" >
                            <div class="d-inline-block trz_fields trz-custom-dropdown  white-dropdown-icon mb-3 w-100" >  <!-- Abdullah added class white-dropdown-icon mb-3 w-100-->
                                <b-dropdown id="dropdown-fields"  text="Add Header Fields (2nd Colunm)" ref="dropdown" class="mb-1 position-relative w-100"> <!-- Abdullah chnaged title text and added class w-100-->
                                    <b-dropdown-form>
                                        <b-form-group @submit.stop.prevent>
                                            <div class="form-group">
                                                <b-form-checkbox-group
                                                    v-model="header_2_column_selected"
                                                    :options="column_options"
                                                    switches

                                                />
                                            </div>

                                        </b-form-group>
                                    </b-dropdown-form>
                                </b-dropdown>
                            </div>

                            <template v-for="(row, index) in header_2_column_selected_view" >
                                <div class="trz_field_values">
                                    <b-form-group class="header-fields" :key="index">  <!-- Abdullah removed class style='max-width:238px;' -->
                                        <b-form-input class = "d-inline-block p-1 mr-2 px-3 align-middle"  disabled  :value="stringView(row)"></b-form-input>
                                        <div class="trz_delete_button payslip-designer-delete">  <!-- Abdullah added class payslip-designer-delete-->
                                            <!-- Abdullah commented this  -->
                                            <!-- <b-icon class="" variant="secondary" @click="removeEntryModal('header-right',row)" icon="trash-fill" role="button" aria-hidden="true" scale="1.5" ></b-icon>  -->
                                             <!-- Abdullah added this code  -->
                                            <b-icon class="" variant="secondary" @click="removeEntryModal('header-right',row)" icon="x" role="button" aria-hidden="true" scale="1.5" ></b-icon>
                                        </div>
                                    </b-form-group>
                                </div>
                            </template>
                            {{clickSelectHeaderLeft}}{{clickSelectHeaderRight}}
                        </div>
                        <div class="col-sm-6 mb-3 mt-3 px-4">  <!-- Abdullah added class px-4-->

                            <!-- Abdullah commented this code  -->
                            <!-- <div role="tablist"> -->
                                <!-- <b-card no-body class="mb-2 no-shadow">
                                    <b-card-header header-tag="header" class="p-0" role="tab">
                                    <b-button block variant="primary"> Preview </b-button>
                                    </b-card-header>

                                    <b-card-body>
                                        <template>
                                            <payslip-design-preview  :company_data="company_info" :header_left="header_column_selected_view" :header_right="header_2_column_selected_view" :footer="footer_show_selected" :showoverlay="showoverlay"></payslip-design-preview>
                                        </template>
                                    </b-card-body>

                                </b-card> -->
                                <!-- <a v-if="payslips != '' && downloadable == 'yes'" :href="$api_url+'/employee_downloadpayslip_all/'+fiscals" class="btn btn-primary float-right mt-4"><b-icon icon="box-arrow-in-down" class="mr-2" scale="1"></b-icon> Download All Payslips</a>
                                <a v-if="payslips != '' && downloadable == 'no'" :href="$api_url+'/employee_downloadpayslip_all/'+fiscals" class="btn btn-primary float-right mt-4 pe-none disabled" aria-disabled="true"><b-icon icon="box-arrow-in-down" class="mr-2" scale="1"></b-icon> Download All Payslips</a> -->
                                <!-- </div> -->
                            <!-- </div> -->
                             <!-- Abdullah added this code  -->
                            <payslip-design-preview :pageurl="$api_url" :company_data="company_info" :header_left="header_column_selected_view" :header_right="header_2_column_selected_view" :footer="footer_show_selected" :showoverlay="showoverlay"></payslip-design-preview>

                    </div>
                </div>
            </div>
        </div>

            <!-- <div>
                <b-modal id="delete-modal" title="Are you sure you want to delete this Field?" hide-footer>
                    <br />
                    <div style="height: 10px;clear:both;"> &nbsp;</div>
                    <a href="javascript:void(0);" class="btn btn-primary btn-full-width"  @click="removeEntry(current_header_type,current_row)">Delete <span v-if="loading != ''"><img :src="this.$api_url+'/images/loading.gif'" width="20"></span></a>
                    &nbsp;&nbsp; <a href="javascript:void(0);" class="btn btn-primary btn-full-width" block @click="$bvModal.hide('delete-modal')">Cancel</a>
                    <div style="height: 5px;clear:both;"> &nbsp;</div>
                </b-modal>
            </div> -->

                <!-- <div class="col-sm-12 row mb-3 mt-3">
                    <div class="d-inline-block trz_fields trz-custom-dropdown mb-1" >
                        <b-dropdown id="dropdown-fields"  text="Select Footer Fields" ref="dropdown" class="mb-1 position-relative">
                            <b-dropdown-form>
                                <b-form-group @submit.stop.prevent>
                                    <div class="form-group">
                                        <b-form-checkbox-group
                                            v-model="footer_column_selected"
                                            :options="column_options"
                                            switches

                                        />
                                    </div>

                                </b-form-group>
                            </b-dropdown-form>
                        </b-dropdown>
                    </div>
                    <div class="d-inline-block ml-3 pt-2">{{footer_show_selected}} {{clickSelect2}}</div>
                </div>  -->

                <!-- <div class="col-sm-12 mb-3 mt-3">
                        <button v-on:click="formSubmit()"  class="btn btn-primary position-static">Save</button>
                </div> -->

		</div>

        <div>
            <b-modal id="delete-modal" title="Are you sure you want to delete this Field?" hide-footer>
                <br />
                <div style="height: 10px;clear:both;"> &nbsp;</div>
                <a href="javascript:void(0);" class="btn btn-primary btn-full-width"  @click="removeEntry(current_header_type,current_row)">Delete <span v-if="loading != ''"><img :src="this.$api_url+'/images/loading.gif'" width="20"></span></a>
                &nbsp;&nbsp; <a href="javascript:void(0);" class="btn btn-primary btn-full-width" block @click="$bvModal.hide('delete-modal')">Cancel</a>
                <div style="height: 5px;clear:both;"> &nbsp;</div>
            </b-modal>
        </div>
    </div>

</template>
<style scoped>
.dashed_border{border-style: dashed !important;}
</style>
<script>
    export default{
        props: ['companyid', , 'flg'],
        mounted() {


        },
        data(){
            return {
                showoverlay:true,
                accindex:1,
                header_column_selected:[],
                header_2_column_selected:[],
                column_options:[],
                default_fields:[],
                header_column_selected_view:[],
                header_2_column_selected_view:[],
                footer_column_selected:[],
                footer_column_selected_view:[],
                header_show_selected:[],
                header_2_show_selected:[],
                footer_show_selected:[],
                disabled:true,
                company_info:[],
                payrun_delete_msg:'Are you sure you want to remove this field ?',
                atl_company_package_title : this.$atl_company_package_title,
                current_header_type:'',
                current_row:'',
                approvepass: '',
                incorrectpass: '',
                loading:'',
            }
        },
        methods:{

            showPreview()
            {

            },
            getCompany:function(x , y)
            {
                if(!this.checkNet()) return false;
                let currentObj = this;
                if(!this.checkNet()) return false;
                axios.get(this.$api_url+'/company/publicinfo' , {
                }).then(function(response){
                    this.company_info = response.data;
                }.bind(this)).catch(function (error){currentObj.serverError(error);});
            },
            removeEntryModal(type,value)
            {
                this.current_header_type = type;
                this.current_row = value;
                this.$bvModal.show('delete-modal');
            },
            removeEntry(type,value)
            {
                //console.log(value);
                this.$bvModal.hide('delete-modal');
                if(type == 'header-left')
                {
                    const index = this.header_column_selected.indexOf(value);
                    console.log(index);
                    if (index > -1)
                    {
                        this.header_column_selected.splice(index, 1);
                        this.formSubmit(index);
                    }
                }
                else if (type == 'header-right')
                {
                    const index = this.header_2_column_selected.indexOf(value);
                    if (index > -1)
                    {
                        this.header_2_column_selected.splice(index, 1);
                        this.formSubmit(index);
                    }
                }

            },
            getPayrollDefaultField()
            {
                if(!this.checkNet()) return false;
                let flg = '';
                if(this.atl_company_package_title=='Provident Fund Only')
                {
                    flg = 'pf_slip';
                }
                else
                {
                    flg = '';
                }

                axios.get(this.$api_url+'/report/payrollreporting/defaultfields' , {
                    params: {
                        flag:flg,
                    }
                }).then(function(response){
                    this.default_fields = response.data;
                    let available_colunms = [];

                    let co = [];
                    var txt = '';
                    let i = 0;
                    this.default_fields.forEach(element => {

                        if(i==1)
                        {
                            co = co.concat([{ text: 'Month' , value: 'month' }]);
                        }
                        if(element=='etin')
                        {
                            txt = 'e-TIN No.';
                        }
                        else if(element=='jobposition')
                        {
                            txt = 'Job Position';
                        }
                        else if(element=='nid')
                        {
                            txt = 'NID';
                        }
                        else if(element=='branch')
                        {
                            txt = 'Work Location';
                        }
                        else if(element=='name')
                        {
                            txt = 'Employee';
                        }
                        else if(element=='employee_code')
                        {
                            txt = 'Employee Code';
                        }
                        else if(element=='joining_date')
                        {
                            txt = 'Date of Joining';
                        }
                        else
                        {
                            txt = this.stringView(element);
                        }
                        co = co.concat([{ text: txt , value: element }]);
                        available_colunms = available_colunms.concat(element);
                        i++;
                    });

                    this.column_options = this.column_options.concat(co);
                    let final_header_column_selected = [];
                    let final_header_2_column_selected = [];
                    this.header_column_selected.forEach(element =>
                    {
                        if(available_colunms.includes(element))
                        {
                            final_header_column_selected.push(element);
                        }
                        else
                        {
                            if(element=='month')
                            {
                                final_header_column_selected.push(element);
                            }
                        }
                    });

                    this.header_2_column_selected.forEach(element =>
                    {
                        if(available_colunms.includes(element))
                        {
                            final_header_2_column_selected.push(element);
                        }
                        else
                        {
                            if(element=='month')
                            {
                                final_header_2_column_selected.push(element);
                            }
                        }
                    });




                    let final_footer_column_selected = [];
                    this.footer_column_selected.forEach(element =>
                    {
                        if(available_colunms.includes(element))
                        {
                            final_footer_column_selected.push(element);
                        }
                        else
                        {
                            if(element=='month')
                            {
                                final_footer_column_selected.push(element);
                            }
                        }


                    });


                    this.footer_column_selected = final_footer_column_selected;
                    this.header_column_selected = final_header_column_selected;
                    this.header_2_column_selected = final_header_2_column_selected;
                    this.showoverlay = false;


                }.bind(this));
            },
            formSubmit()
            {
                let final_array = [];
                final_array.push(this.header_column_selected);
                final_array.push(this.header_2_column_selected);
                final_array.push(this.footer_column_selected);


                var text = JSON.stringify(final_array);
                let formData = new FormData();
                formData.append('payslip_fields', text);
                formData.append('company_id', this.company_id);
                this.component_data = [];
                let currentObj = this;

                axios.post(this.$api_url + '/company/payslip-field-settings/save', formData)
                    .then(function (response)
                    {
                        //this.$bvToast.toast(response.data.message, {title: 'Success',variant: 'success',solid: true});

                    }.bind(this))
                    .catch(function (error)
                    {
                        //this.$bvToast.toast(error.response.data.errors.toString(), {title: 'Error!',variant: 'danger',solid: true});
                    });

            },

            formSubmitWithPass(index)
            {
                this.loading='load';
                var pass= '';
                var type = this.current_header_type;
                if(this.approvepass!='')
                {
                    var pass=this.approvepass;
                    this.loading='load';
                }
                let final_array = [];
                final_array.push(this.header_column_selected);
                final_array.push(this.header_2_column_selected);
                final_array.push(this.footer_column_selected);


                var text = JSON.stringify(final_array);
                let formData = new FormData();
                formData.append('payslip_fields', text);
                formData.append('company_id', this.company_id);
                formData.append('password', pass);
                this.component_data = [];
                let currentObj = this;

                axios.post(this.$api_url + '/company/payslip-field-settings/update', formData)
                    .then(function (response)
                    {

                        if(response.data.message)
                        {
                            this.$bvToast.toast(response.data.message, {title: 'Error!',variant: 'danger',solid: true});
                            this.current_header_type = '';
                            this.current_row = '';


                        }

                        if(response.data.success)
                        {
                            this.$bvToast.toast(response.data.success, {title: 'Saved!',variant: 'success',solid: true});
                            this.current_header_type = '';
                            this.current_row = '';
                            if(type=='header-left')
                            {

                                const index = this.header_column_selected.indexOf(value);
                                if (index > -1)
                                {
                                    // only splice array when item is found
                                    this.header_column_selected.splice(index, 1);

                                }

                            }
                            else if (type=='header-right')
                            {

                                const index = this.header_2_column_selected.indexOf(value);
                                if (index > -1)
                                {
                                    // only splice array when item is found
                                    this.header_2_column_selected.splice(index, 1);

                                }

                            }
                        }
                        this.loading='';
                        this.$bvModal.hide('delete-payrun-modal');

                        //this.$bvToast.toast(response.data.message, {title: 'Success',variant: 'success',solid: true});

                    }.bind(this))
                    .catch(function (error)
                    {
                        //this.$bvToast.toast(error.response.data.errors.toString(), {title: 'Error!',variant: 'danger',solid: true});
                    });

            },
            get_payslip_field_settings: function()
            {
                //
                if(!this.checkNet()) return false;
                axios.get(this.$api_url+'/company/payslip-field-settings' , {
                }).then(function(response){

                    let company_access_settings_temp = {};
                    company_access_settings_temp = response.data;
                    let final_header_column_selected = [];
                    let final_header_2_column_selected = [];
                    let final_footer_column_selected = [];

                    for (const [key, value] of Object.entries(company_access_settings_temp)) {


                        if(key=='header-left')
                        {
                            for (const [key2, value2] of Object.entries(value)) {

                                if(value2 != '')
                                {
                                    final_header_column_selected.push(value2);
                                }

                            }

                        }
                        if(key=='header-right')
                        {
                            for (const [key2, value2] of Object.entries(value)) {

                                if(value2 != '')
                                {
                                    final_header_2_column_selected.push(value2);
                                }

                            }

                        }
                        if(key=='footer')
                        {
                            for (const [key2, value2] of Object.entries(value)) {

                                if(value2 != '')
                                {
                                    final_footer_column_selected.push(value2);
                                }
                            }

                        }



                    }

                    this.footer_column_selected = final_footer_column_selected;
                    this.header_column_selected = final_header_column_selected;
                    this.header_2_column_selected = final_header_2_column_selected;


                    this.getPayrollDefaultField();

                }.bind(this));
            },
            stringView(str) {


                if(str=='etin')
                {
                    str = 'e-TIN No.';
                    return str;
                }
                else if(str=='jobposition')
                {
                    str = 'Job Position';
                    return str;
                }
                else if(str=='nid')
                {
                    str = 'NID';
                    return str;
                }
                else if(str=='branch')
                {
                    str = 'Work Location';
                    return str;
                }

                else if(str=='name')
                {
                    str = 'Employee';
                    return str;
                }
                else if(str=='employee_code')
                {
                    str = 'Employee Code';
                    return str;
                }
                else if(str=='joining_date')
                {
                    str = 'Date of Joining';

                    return str;
                }
                var i, frags = str.split('_');
                for (i=0; i<frags.length; i++) {
                    frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
                }
                return frags.join(' ');
            },
            setcolumn: function()
            {
                this.$refs.dropdown.hide(true);
            },
            capitalizeTheFirstLetterOfEachWord(words) {
            var separateWord = words.toLowerCase().split(' ');
            for (var i = 0; i < separateWord.length; i++) {
                separateWord[i] = separateWord[i].charAt(0).toUpperCase() +
                separateWord[i].substring(1);
            }
            return separateWord.join(' ');
            }
        },
        created: function(){
          this.get_payslip_field_settings();
          this.getCompany();
        },
        computed:
        {

            clickSelectHeaderLeft()
            {
                var lt = this.header_column_selected_view.length;

                this.header_column_selected_view = this.header_column_selected;
                if(this.header_column_selected_view.length !=  lt)
                {
                    this.header_column_selected_view = this.header_column_selected;
                    this.formSubmit();
                }

                this.header_show_selected = this.header_column_selected_view.join();
                this.header_show_selected = this.header_show_selected.replace('branch','work_location');
                this.header_show_selected = this.header_show_selected.replaceAll("_", " ");
                this.header_show_selected = this.header_show_selected.replaceAll(",", " , ");
                this.header_show_selected = this.capitalizeTheFirstLetterOfEachWord(this.header_show_selected);

                if(this.header_column_selected.length ==0)
                {
                    this.header_show_selected = 'None Selected';
                }




            },
            clickSelectHeaderRight()
            {
                var lt = this.header_2_column_selected_view.length;

                this.header_2_column_selected_view = this.header_2_column_selected;
                if(this.header_2_column_selected_view.length !=  lt)
                {
                    this.header_2_column_selected_view = this.header_2_column_selected;
                    this.formSubmit();
                }

                this.header_2_show_selected = this.header_2_column_selected_view.join();
                this.header_2_show_selected = this.header_2_show_selected.replace('branch','work_location');
                this.header_2_show_selected = this.header_2_show_selected.replaceAll("_", " ");
                this.header_2_show_selected = this.header_2_show_selected.replaceAll(",", " , ");
                this.header_2_show_selected = this.capitalizeTheFirstLetterOfEachWord(this.header_show_selected);

                if(this.header_2_column_selected.length ==0)
                {
                    this.header_2_show_selected = 'None Selected';
                }



            },
            clickSelect2()
            {
                var lt = this.footer_column_selected_view.length;

                this.footer_column_selected_view = this.footer_column_selected;
                if(this.footer_column_selected_view.length !=  lt)
                {
                    this.footer_column_selected_view = this.footer_column_selected;
                }

                this.footer_show_selected = this.footer_column_selected_view.join();
                this.footer_show_selected = this.footer_show_selected.replace('branch','work_location');
                this.footer_show_selected = this.footer_show_selected.replaceAll("_", " ");
                this.footer_show_selected = this.footer_show_selected.replaceAll(",", " , ");
                this.footer_show_selected = this.capitalizeTheFirstLetterOfEachWord(this.footer_show_selected);

                if(this.footer_column_selected.length ==0)
                {
                    this.footer_show_selected = 'None Selected';
                }



            }
        }
    }
</script>
<style>
.company-form-container .custom-control-label::before {
	top: 2px !important;
}
.trz_delete_button {
	position: absolute;
	right: -25px;
	top: 6px;
}
.trz_field_values .header-fields {
	position: relative;
}

.trz_dynamic_field_wrapper .dropdown-menu.show .custom-control.custom-control-inline.custom-switch {
	width: 100%;
}
</style>
